import { KbCardPage } from "@/components/kb/KbCardPage";

export function Card008SessionTemplates() {
  return <KbCardPage slug="card-008-session-templates" />;
}

(Card008SessionTemplates as unknown as { path: string }).path = "/methodology/008";
